/* Restored draft-only mix-and-match UI. Existing bundle SKU, no inventory mutation.
   The current form owns all three purchase modes; the older product controller
   intentionally ignores it because it has no data-kcx-form attribute. */
(() => {
  'use strict';
  if (window.KlarigoBundleUI) return;
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'nl', {style:'currency',currency:currency || 'EUR'}).format(cents / 100);
  function init(scope = document) {
    const forms = [...scope.querySelectorAll('[data-kcb-form]')];
    if (scope.matches?.('[data-kcb-form]')) forms.push(scope);
    forms.forEach(form => {
      if (form.dataset.kcbReady) return;
      const root = form.closest('[data-kcx-product]');
      if (!root) return;
      let labels;
      try { labels = JSON.parse(form.querySelector('[data-kcb-labels]').textContent); } catch (_) { return; }
      form.dataset.kcbReady = 'true';
      const direct = form.dataset.kcbDirect === 'true';
      const currency = root.dataset.currency || 'EUR';
      const radios = [...form.querySelectorAll('input[type="radio"][data-kcb-variant]')];
      const hidden = form.querySelector('input[type="hidden"][data-kcb-variant]');
      const current = () => radios.find(input => input.checked) || hidden;
      const builder = form.querySelector('[data-kcb-builder]');
      const dialog = form.querySelector('[data-kcb-dialog]');
      const cards = [...form.querySelectorAll('[data-kcb-design]')];
      const slots = [...form.querySelectorAll('[data-kcb-slot]')];
      const search = form.querySelector('[data-kcb-search]');
      const addon = form.querySelector('[data-kcb-addon]');
      const extra = form.querySelector('[data-kcb-extra]');
      const submit = form.querySelector('[data-kcb-add]');
      const errors = form.querySelector('[data-kcb-error]');
      const sticky = root.querySelector('[data-kcx-sticky]');
      const bundleRadio = radios.find(input => input.dataset.kind === 'bundle');
      const selected = [null,null,null];
      if (!direct) selected[0] = {id:form.dataset.kcbItemId,title:form.dataset.kcbItemTitle,handle:form.dataset.kcbItemHandle,completeId:form.dataset.kcbCompleteId,completePrice:Number(form.dataset.kcbCompletePrice)};
      let activeSlot = null;
      let busy = false;
      let checking = false;
      let mainVisible = false;
      let destroyed = false;
      let controller;
      const bundleSupported = Boolean(dialog && typeof dialog.showModal === 'function');
      const eligible = form.dataset.kcbAvailable === 'true' && bundleSupported;
      if (bundleRadio) bundleRadio.disabled = !eligible;
      const route = () => window.Shopify?.routes?.root || window.routes?.rootUrl || '/';
      const count = () => selected.filter(Boolean).length;
      const bundleMode = () => current()?.dataset.kind === 'bundle';
      const validBundle = () => eligible && count() === 3 && new Set(selected.map(d => d.id)).size === 3;
      const showError = text => { errors.querySelector('[data-kcb-error-text]').textContent = text; errors.hidden = false; errors.focus(); };
      const hideError = () => { errors.hidden = true; };
      const updateSticky = () => {
        if (!sticky) return;
        const overlay = document.querySelector('.PageOverlay');
        const covered = Boolean(dialog?.open || document.querySelector('.NewsletterPopup[aria-hidden="false"]') || overlay?.classList.contains('is-visible') || overlay?.classList.contains('is-active'));
        sticky.hidden = mainVisible || covered;
      };
      const updateCards = () => {
        const term = search?.value.trim().toLocaleLowerCase() || '';
        let visible = 0;
        cards.forEach(card => {
          const used = selected.some((d,index) => index !== activeSlot && d?.id === card.dataset.designId);
          const available = activeSlot === 0 ? card.dataset.completeAvailable === 'true' : card.dataset.plateAvailable === 'true';
          const match = (!term || card.dataset.search.toLocaleLowerCase().includes(term)) && available;
          card.hidden = !match;
          card.disabled = used || !available || busy;
          card.classList.toggle('is-used', used);
          if (match) visible++;
        });
        const empty = form.querySelector('[data-kcb-empty]');
        if (empty) empty.hidden = visible > 0;
      };
      const render = (changeUrl = false) => {
        const variant = current();
        if (!variant) return;
        const mode = variant.dataset.kind;
        const isBundle = mode === 'bundle';
        if (builder) builder.hidden = !isBundle;
        if (extra && mode !== 'complete') extra.value = '';
        if (addon) addon.hidden = mode !== 'complete';
        radios.forEach(input => input.closest('.kp-offer')?.classList.toggle('is-selected', input.checked));
        const price = Number(variant.dataset.price);
        root.querySelector('[data-kcx-price]').textContent = money(price,currency);
        root.querySelectorAll('[data-kcx-includes],[data-kcx-box]').forEach(node => {node.textContent = isBundle ? labels.contents : mode === 'plate' ? labels.plate : labels.complete;});
        let total = price;
        const withExtra = mode === 'complete' && Boolean(extra?.value);
        if (extra) {
          const totalNode = form.querySelector('[data-kcb-extra-total]');
          if (withExtra) total += Number(extra.selectedOptions[0].dataset.price);
          totalNode.hidden = !withExtra;
          form.querySelector('[data-kcb-extra-preview]').hidden = !withExtra;
          if (withExtra) {
            totalNode.textContent = `${labels.total}: ${money(total,currency)}`;
            const chosenExtra = extra.selectedOptions[0];
            const image = form.querySelector('[data-kcb-extra-image]');
            image.hidden = !chosenExtra.dataset.image;
            if (chosenExtra.dataset.image) image.src = chosenExtra.dataset.image;
            else image.removeAttribute('src');
            image.alt = chosenExtra.dataset.title;
            form.querySelector('[data-kcb-extra-title]').textContent = chosenExtra.dataset.title;
          }
        }
        root.querySelectorAll('[data-kcx-mobile-price]').forEach(node => {node.textContent = money(total,currency);});
        const progress = form.querySelector('[data-kcb-progress]');
        if (progress) progress.textContent = labels.progress.replace('{count}',String(count()));
        for (let index = 0; index < 3; index++) {
          const property = form.querySelector(`[data-kcb-property="${index+1}"]`);
          const component = form.querySelector(`[data-kcb-component="${index+1}"]`);
          if (!property || !component) continue;
          property.disabled = component.disabled = !isBundle;
          property.value = selected[index]?.title || '';
          component.value = index === 0 ? selected[index]?.completeId || '' : selected[index]?.plateId || '';
        }
        const comparison = root.querySelector('[data-kcx-compare]');
        const saving = form.querySelector('[data-kcb-saving]');
        let looseTotal = 0;
        if (isBundle && validBundle()) looseTotal = selected[0].completePrice + selected[1].platePrice + selected[2].platePrice;
        const hasSaving = isBundle && looseTotal > price;
        if (comparison) {comparison.hidden = !hasSaving;if (hasSaving) comparison.textContent = money(looseTotal,currency);}
        if (saving) {saving.hidden = !hasSaving;if (hasSaving) saving.textContent = `${labels.saving}: ${money(looseTotal-price,currency)} (${labels.separate}: ${money(looseTotal,currency)}).`;}
        const unavailable = variant.dataset.available !== 'true' || (isBundle && !eligible);
        submit.disabled = busy || unavailable || (isBundle && !validBundle());
        let text = labels.singleAdd;
        if (checking) text = labels.checking;
        else if (busy) text = labels.working;
        else if (unavailable) text = labels.soldOut;
        else if (isBundle) text = validBundle() ? labels.add : labels.remaining.replace('{count}',String(3-count())).replace('plaatje(s)',count()===2?'plaatje':'plaatjes');
        else if (withExtra) text = labels.addBoth;
        form.querySelector('[data-kcb-add-label]').textContent = text;
        // Lock selection during an in-flight request without losing original stock state.
        radios.forEach(input => {input.disabled = busy || input.dataset.available !== 'true' || (input.dataset.kind === 'bundle' && !eligible);});
        slots.forEach(slot => {slot.disabled = busy;});
        if (extra) extra.disabled = busy;
        if (changeUrl && window.history?.replaceState) {
          const url = new URL(window.location.href);
          if (isBundle && !direct) {url.searchParams.set('variant',form.dataset.kcbCompleteId);url.searchParams.set('klarigo_bundle','3');}
          else {url.searchParams.set('variant',variant.value);url.searchParams.delete('klarigo_bundle');}
          window.history.replaceState(window.history.state,'',url);
        }
        updateSticky();
      };
      const closeDialog = () => {if (dialog?.open) dialog.close();};
      slots.forEach(slot => slot.addEventListener('click', () => {
        if (busy || !bundleSupported) return;
        activeSlot = Number(slot.dataset.kcbSlot)-1;
        search.value = '';
        updateCards();
        dialog.showModal();
        document.documentElement.classList.add('kcb-modal-open');
        updateSticky();
        search.focus();
      }));
      form.querySelector('[data-kcb-close]')?.addEventListener('click',closeDialog);
      dialog?.addEventListener('close',() => {document.documentElement.classList.remove('kcb-modal-open');updateSticky();});
      dialog?.addEventListener('click',event => {if (event.target !== dialog) return;const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)closeDialog();});
      search?.addEventListener('input',updateCards);
      search?.addEventListener('keydown',event => {if(event.key === 'Enter')event.preventDefault();});
      cards.forEach(card => card.addEventListener('click', () => {
        if (busy || card.disabled || activeSlot === null) return;
        const d = card.dataset;
        selected[activeSlot] = {id:d.designId,title:d.title,handle:d.handle,plateId:d.plateId,completeId:d.completeId,platePrice:Number(d.platePrice),completePrice:Number(d.completePrice)};
        const slot = slots.find(node => Number(node.dataset.kcbSlot)-1 === activeSlot);
        slot.classList.add('is-selected');
        slot.querySelector('[data-kcb-slot-title]').textContent = d.title;
        slot.querySelector('[data-kcb-slot-action]').textContent = labels.change;
        const media = slot.querySelector('[data-kcb-slot-media]');
        media.replaceChildren();
        if (d.image) {const image=document.createElement('img');image.src=d.image;image.alt='';image.width=56;image.height=56;media.appendChild(image);} else media.textContent='✓';
        hideError();render();closeDialog();slot.focus();
      }));
      radios.forEach(input => input.addEventListener('change',() => {hideError();render(true);}));
      extra?.addEventListener('change',() => {hideError();render();});
      form.addEventListener('submit',async event => {
        if (busy) {event.preventDefault();return;}
        const variant = current();
        if (!variant || variant.dataset.available !== 'true') {event.preventDefault();return;}
        const isBundle = bundleMode();
        const withExtra = variant.dataset.kind === 'complete' && Boolean(extra?.value);
        if (!isBundle && !withExtra) return; // Native single-item form remains functional.
        event.preventDefault();
        if (isBundle && !validBundle()) {slots.find(slot => !selected[Number(slot.dataset.kcbSlot)-1])?.click();return;}
        hideError();busy=true;checking=isBundle;render();
        controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(),20000);
        let postStarted = false;
        try {
          const items = [];
          if (isBundle) {
            // Advisory availability check only, not a reservation or component decrement.
            const plans = selected.map((d,index) => ({handle:d.handle,id:index===0?d.completeId:d.plateId}));
            plans.push({handle:form.dataset.kcbBundleHandle,id:form.dataset.kcbBundleId,bundle:true});
            await Promise.all(plans.map(async plan => {
              const response = await fetch(`${route()}products/${encodeURIComponent(plan.handle)}.js`,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:controller.signal});
              if (!response.ok) throw new Error('network');
              const product = await response.json();
              const fresh = product.variants?.find(v => String(v.id) === String(plan.id));
              if (!fresh?.available) throw new Error('unavailable');
              if (plan.bundle && Number(fresh.price) !== Number(form.dataset.kcbBundlePrice)) throw new Error('price_changed');
            }));
            const properties = {'_Klarigo_bundle':'1_base_3_plates_v1'};
            selected.forEach((d,index) => {properties[`Afbeelding ${index+1}`]=d.title;properties[`_Klarigo_component_${index+1}_variant_id`]=index===0?d.completeId:d.plateId;});
            items.push({id:Number(form.dataset.kcbBundleId),quantity:1,properties});
          } else {
            items.push({id:Number(variant.value),quantity:1},{id:Number(extra.value),quantity:1});
          }
          checking=false;render();
          postStarted=true;
          const response = await fetch(`${route()}cart/add.js`,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items}),signal:controller.signal});
          const result = await response.json();
          if (!response.ok || result.status) throw new Error('uncertain');
          window.location.assign(`${route()}cart`);
        } catch (error) {
          if (destroyed) return;
          const code = postStarted ? 'uncertain' : (['unavailable','price_changed'].includes(error.message) ? error.message : 'network');
          showError(labels[code]);
        } finally {
          window.clearTimeout(timeout);controller.abort();busy=false;checking=false;if (!destroyed) render();
        }
      });
      let observer;
      if (sticky && 'IntersectionObserver' in window) {observer=new IntersectionObserver(entries=>{mainVisible=entries[0].isIntersecting;updateSticky();},{threshold:.6});observer.observe(submit);}
      const overlay = document.querySelector('.PageOverlay');
      const overlayObserver = new MutationObserver(updateSticky);
      if (overlay) overlayObserver.observe(overlay,{attributes:true,attributeFilter:['class']});
      const popup = document.querySelector('.NewsletterPopup');
      if (popup) overlayObserver.observe(popup,{attributes:true,attributeFilter:['aria-hidden']});
      const pageShow = () => {busy=false;checking=false;render();};
      window.addEventListener('pageshow',pageShow);
      form._kcbDestroy = () => {destroyed=true;controller?.abort();observer?.disconnect();overlayObserver.disconnect();window.removeEventListener('pageshow',pageShow);closeDialog();};
      if (bundleRadio && eligible && new URL(window.location.href).searchParams.get('klarigo_bundle') === '3') bundleRadio.checked=true;
      render();
    });
  }
  window.KlarigoBundleUI = {init};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-kcb-form]').forEach(form=>form._kcbDestroy?.()));
})();
